import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppService } from 'src/app/_services/app.service';
import { MarketContributeComponent } from '../market-contribute.component';

@Component({
    selector: 'app-contribution-confirm',
    templateUrl: './contribution-confirm.component.html',
    standalone: false
})
export class ContributionConfirmComponent implements OnInit {

  reason: string = '';

  constructor(public dialogRef: MatDialogRef<MarketContributeComponent>, @Inject(MAT_DIALOG_DATA) public data) {
  }

  ngOnInit() {
  }

  /** Yes button event */
  OnClickYes() {
    if (this.reason.trim() !== '') {
      this.dialogRef.close(this.reason);
    }
  }

  /** No button event */
  OnClickNo () {
    this.dialogRef.close('');
  }

}
